var render, staticRenderFns
import script from "./NsCarouselItems.vue?vue&type=script&lang=js&"
export * from "./NsCarouselItems.vue?vue&type=script&lang=js&"
import style0 from "./NsCarouselItems.vue?vue&type=style&index=0&id=5c0a76c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a76c1",
  null
  
)

export default component.exports